<div class="box green_box"></div>
<div class="box pink_box"></div>
<!-- <div class="blur_ball">
    <img src="img/small.svg" class="top1" alt="" />
    <img src="img/small.svg" class="bottom1" alt="" />
</div> -->

<router-outlet></router-outlet>